import { Account, ID } from "appwrite";
import { account, appwrite } from "../config.js/appwrite_config";

export const signupWithMagicURL = async (email, success, error) => {
	try {
		const account = new Account(appwrite);

		const user = await account.createMagicURLSession(ID.unique(), email, window.location.href + "confirm");
		console.log("signedup", user);
		success(user);
	} catch (e) {
		error(e);
	}
};

export const loginWithMagicURL = async (userid, secret) => {
	const account = new Account(appwrite);
	const user = await account.updateMagicURLSession(userid, secret);
	console.log("logged in", user);
	return user;
};

export const fetchUserDetails = async (callback, error) => {
	try {
		const user = await account.get();
		callback(user);
	} catch (e) {
		error(e);
	}
};

export const checkUserExists = async (exist) => {
	try {
		await account.get();
		return true;
	} catch (error) {
		return false;
	}
};
